module.exports = __webpack_public_path__ + "233a5ac526e80ab046d10b4c8aff8d7d.svg";